import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { IPermitStats } from './IPermitStats'
import { TimeRangeProjectAnalytics } from '../TimeRangeProjectAnalytics'
import { PermitStatsByMonth } from './PermitStatsByMonth'
import { PermitStatsByStatus } from './PermitStatsByStatus'
import { OpenCheckInsStats } from './OpenCheckInsStats'
import { CheckInUsersStats } from './CheckInUsersStats'

export class PermitStats extends Entity<IPermitStats> {
  total: number

  @Type(() => TimeRangeProjectAnalytics)
  lastThirtyDays: TimeRangeProjectAnalytics

  @Type(() => PermitStatsByMonth)
  byMonth: Array<PermitStatsByMonth>

  @Type(() => PermitStatsByStatus)
  byStatus: Array<PermitStatsByStatus>

  @Type(() => OpenCheckInsStats)
  openCheckIns?: OpenCheckInsStats

  @Type(() => CheckInUsersStats)
  checkInUsersStats?: CheckInUsersStats

  public hasCheckInStats(): boolean {
    return !!this.openCheckIns
  }

  public static new(payload: unknown): PermitStats {
    const entity = plainToInstance(PermitStats, payload)

    return entity
  }
}
